const sites = {
    'app.nucleuslearning.tech': {
        id: 0,
        title: 'Nucleus Learning',
        shortTitle: 'Nucleus',
        description: 'Access Nucleus Learning courses and assessments.',
        supportEmail: 'support@nucleustech.org',
        platformUrl: 'https://learn.nucleuslearning.tech',
        googlePlayStore: 'https://play.google.com/store/apps/details?id=com.nucleus.production',
        appleAppStore: 'https://apps.apple.com/gb/app/nucleus-learning/id6450541081',
        styles: {
            font: 'Open Sans',
            colors: {
                primary: '#2674ba',
                contrast: '#183448',
                shadow: '#E8EAEE',
                darker: '#183448'
            },
            backgroundStyle: 'url(\'/img/0/watermark.svg\') bottom -200px right -200px / 1000px auto no-repeat',
            backgroundOpacity: 0.05,
            sidebarStyle: 'url(\'/img/0/watermark.svg\') bottom -10% right 150% / 120% auto no-repeat',
            sidebarOpacity: 0.1,
            iconBackground: '#fff'
        }
    },
    'academy2.leeaint.com': {
        devUrl: 'leea-dev.app.nucleuslearning.tech',
        id: 140,
        title: 'LEEA Academy',
        shortTitle: 'LEEA',
        description: 'For LEEA students to access courses and assessments.',
        supportEmail: 'customersupport@leeaint.com',
        platformUrl: 'https://elearning.leeaint.com',
        microsoftStore: 'https://apps.microsoft.com/store/detail/leea-academy/9NV2934L98T0',
        googlePlayStore: 'https://play.google.com/store/apps/details?id=com.leea',
        appleAppStore: 'https://apps.apple.com/app/leea-academy/id1637443669',
        assessmentAgreement: true,
        styles: {
            font: 'Inter',
            colors: {
                primary: '#1D3058',
                contrast: '#64CE95',
                shadow: '#E8EAEE',
                darker: '#0f4382'
            },
            backgroundStyle: 'url(\'/img/140/watermark.svg\') center / cover',
            backgroundOpacity: 0.1,
            sidebarStyle: 'url(\'/img/140/watermark.svg\') bottom / 100% auto no-repeat',
            sidebarOpacity: 0.1
        }
    },
    'app.ggf.org.uk': {
        devUrl: 'ggf-dev.app.nucleuslearning.tech',
        id: 1863,
        title: 'Glass & Glazing Federation',
        shortTitle: 'GGF',
        description: 'For GGF members to access courses and assessments.',
        supportEmail: 'support@ggf.org.uk',
        platformUrl: 'https://training.ggf.org.uk',
        googlePlayStore: 'https://play.google.com/store/apps/details?id=com.nucleus.ggf',
        appleAppStore: 'https://apps.apple.com/gb/app/ggftraining/id6736402115',
        styles: {
            font: 'Montserrat',
            colors: {
                primary: '#1c8cde',
                contrast: '#eb7852',
                shadow: '#E8EAEE',
                darker: '#b0defa'
            },
            backgroundStyle: 'url(\'/img/1863/watermark.svg\') bottom -100px right / 600px auto no-repeat',
            backgroundOpacity: 0.1,
            sidebarStyle: 'url(\'/img/1863/watermark.svg\') bottom center /80% auto no-repeat',
            sidebarOpacity: 0.1,
            iconBackground: '#fff'
        }
    },
    'app.ukwa.org.uk': {
        devUrl: 'ukwa-dev.app.nucleuslearning.tech',
        id: 1381,
        title: 'UK Warehousing Association',
        shortTitle: 'UKWA',
        description: 'For UKWA members to access courses and assessments.',
        supportEmail: 'info@ukwa.org.uk',
        platformUrl: 'https://ukwa.admin.learn.nucleuslearning.tech',
        googlePlayStore: 'https://play.google.com/store/apps/details?id=com.nucleus.ukwa',
        appleAppStore: 'https://apps.apple.com/gb/app/ukwa/id6482354841',
        styles: {
            font: 'Raleway',
            colors: {
                primary: '#10273C',
                contrast: '#B10023',
                shadow: '#E8EAEE',
                darker: '#405263'
            },
            backgroundStyle: 'url(\'/img/1381/watermark.svg\') center / 90% auto no-repeat',
            backgroundOpacity: 0.1,
            sidebarStyle: 'url(\'/img/1381/watermark.svg\') bottom 10% center / 80% auto no-repeat',
            sidebarOpacity: 0.1,
            iconBackground: '#fff'
        }
    },
    'assessments.asfp.org.uk':{
        devUrl: 'asfp-dev.app.nucleuslearning.tech',
        id: 3817,
        title: 'Association for Specialist Fire Protection',
        shortTitle: 'ASFP',
        description: 'This app will allow ASFP delegates to test their knowledge following the training course attended. The mock questions in this app are mock and the question you answer during your IFE examination will be different.',
        supportEmail: 'training@asfp.org.uk',
        platformUrl: 'https://training.asfp.org.uk',
        styles: {
            font: 'Roboto',
            colors: {
                primary: '#2e3a59',
                contrast: '#e73138',
                shadow: '#acb0ba',
                darker: '#0b1d3c'
            },
            backgroundStyle: 'url(\'/img/3817/watermark.svg\') bottom -100px right -100px / 600px auto no-repeat',
            backgroundOpacity: 0.1,
            sidebarStyle: 'url(\'/img/3817/watermark.svg\') bottom center / 80% auto no-repeat',
            sidebarOpacity: 0.25,
            iconBackground: '#fff'
        }
    }
};

module.exports = { sites };
